import {AppLayout} from "../layout/AppLayout.tsx";
import {PublicHomePage} from "../features/home/pages/PublicHomePage.tsx";
import {SignInLayout} from "../features/users-management";
import {AuthorizePage} from "../features/users-management/oauth2/pages/AuthorizePage.tsx";
import {SignOutPage} from "../features/home/pages/SignOutPage.tsx";
import {SignUpLayout} from "../features/users-management";
import {ResetPasswordLayout} from "../features/users-management";
import {RequireAuth} from "../utils/RequireAuth.tsx";
import {IndexPage as DashboardPage} from "../features/dashboard/pages/IndexPage.tsx";
import {SubscriptionsLayout} from "../features/billing-management";
import {OrganizationsLayout} from "../features/accounts-management";
import {AccountApplicationsLayout} from "../features/accounts-management";
import {UserProfileAttributesLayout} from "../features/users-management";
import {AccountsLayout} from "../features/accounts-management";
import {ApplicationErrorPage} from "@flexinet/ui-components";
import {ApplicationsLayout} from "../features/accounts-management";
import {ProductsLayout} from "../features/billing-management";
import {IndexPage as PaymentMethodsIndexPage, PaymentProfileSelectionPage} from "../features/billing-management/payment-profiles";
import {BillingProviderSelectionPage, BillingProviderDetailPage, ProviderSetupPage} from "../features/billing-management/billing-providers";
import {AddPage as PaymentMethodSetupPage} from "../features/billing-management/payment-profiles";
import {CreateSubscriptionPage} from "../features/billing-management/subscriptions";
import {RequireBillingCustomer} from "../features/billing-management/customers/components/RequireBillingCustomer";



export const routesConfig = [{
    path: '/',
    element: <AppLayout/>,
    errorElement: <ApplicationErrorPage/>,
    children: [{
        index: true,
        element: <PublicHomePage/>
    }, {
        path: 'sign-in/*',
        element: <SignInLayout/>
    }, {
        path: 'oauth2/authorize*',
        element: <AuthorizePage/>
    }, {
        path: 'sign-out',
        element: <SignOutPage/>
    }, {
        path: 'sign-up/*',
        element: <SignUpLayout/>
    }, {
        path: 'reset-password/*',
        element: <ResetPasswordLayout/>
    }, {
        path: 'dashboard',
        element: <RequireAuth><DashboardPage/></RequireAuth>
    }, {
        path: 'account-applications/*',
        element: <RequireAuth> <AccountApplicationsLayout/> </RequireAuth>
    }, {
        path: 'accounts-old/*',
        element: <RequireAuth> <AccountsLayout/> </RequireAuth>
    }, {
        path: 'account/*',
        element: <RequireAuth> <AccountsLayout/> </RequireAuth>
    }, {
        path: 'user-profile/*',
        element: <RequireAuth> <UserProfileAttributesLayout/></RequireAuth>
    }, {
        path: 'organizations/*',
        element: <RequireAuth> <OrganizationsLayout/> </RequireAuth>
    }, {
        path: 'subscriptions/*',
        element: <RequireAuth><RequireBillingCustomer><SubscriptionsLayout/></RequireBillingCustomer></RequireAuth>
    }, {
        path: 'applications/*',
        element: <RequireAuth> <ApplicationsLayout/> </RequireAuth>
    }, {
        path: 'products/*',
        element: <RequireAuth> <ProductsLayout/> </RequireAuth>
    }, {
        path: 'payment-methods',
        element: <RequireAuth><RequireBillingCustomer><PaymentMethodsIndexPage/></RequireBillingCustomer></RequireAuth>
    }, {
        path: 'billing/payment-profile-selection',
        element: <RequireAuth><RequireBillingCustomer><PaymentProfileSelectionPage/></RequireBillingCustomer></RequireAuth>
    }, {
        path: 'billing/providers',
        element: <RequireAuth><RequireBillingCustomer><BillingProviderSelectionPage/></RequireBillingCustomer></RequireAuth>
    }, {
        path: 'billing/providers/:id',
        element: <RequireAuth><RequireBillingCustomer><BillingProviderDetailPage/></RequireBillingCustomer></RequireAuth>
    }, {
        path: 'billing/provider-selection',
        element: <RequireAuth><RequireBillingCustomer><BillingProviderSelectionPage/></RequireBillingCustomer></RequireAuth>
    }, {
        path: 'billing/provider-setup',
        element: <RequireAuth><RequireBillingCustomer><ProviderSetupPage/></RequireBillingCustomer></RequireAuth>
    }, {
        path: 'billing/payment-method-setup',
        element: <RequireAuth><RequireBillingCustomer><PaymentMethodSetupPage/></RequireBillingCustomer></RequireAuth>
    }, {
        path: 'billing/create-subscription',
        element: <RequireAuth><RequireBillingCustomer><CreateSubscriptionPage/></RequireBillingCustomer></RequireAuth>
    }]
}]
